<template>


    <d-card-body class="pt-0">
      <div class="card-body p-0 pb-3 text-center mtop responsive-table">
        <table class="table mb-0 mr-4" style="border: 1px #dee2e6 solid;table-layout: fixed;">
          <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">Klient</th>
            <th scope="col" class="border-0">Spółka</th>
            <th scope="col" class="border-0">Data ostatniej płatności</th>
            <th scope="col" class="border-0">Pozostało do spłaty</th>
            <th scope="col" class="border-0">Akcja</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="schedule in schedules">
            <td>
              <dt>Klient</dt>
              <dd>
                <router-link :to="`/klienci/edycja/${parseInt(schedule.client_id, 10)}`">
                  {{ schedule.client_name }} {{ schedule.client_last_name }}
                </router-link>
              </dd>
            </td>
            <td>
              <dt>Spółka</dt>
              <dd>{{ schedule.company_name }}</dd>
            </td>
            <td>
              <dt>Data ostatniej płatności</dt>
              <dd>{{ schedule.last_payment_date }}</dd>
            </td>
            <td class="cell-penalty">
              <dt>Pozostało do spłaty</dt>
              <dd>{{ toNumber(schedule.to_finish_credit) }} zł</dd>
            </td>
            <td>
              <dt>Akcja</dt>
              <d-button @click="editSchedule(schedule)"><i class="material-icons">edit</i> Edytuj</d-button>
            </td>
          </tr>
          </tbody>
        </table>
        <p v-if="schedules.length < 1" class="text-info">Brak kończących się umów.</p>
      </div>
    </d-card-body>
</template>

<script>
  import SsDate from '../common/SsDate'

export default {
  name: 'users-overview',
  components: {
    SsDate
  },
  props: {
    props: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      schedules: []
    };
  },
  methods: {
    toNumber (number) {
      return Vue.toNumber(number);
    },
    editSchedule (schedule) {
      this.$router.push({name: 'contract-edit', params: { client_id: schedule.client_id, schedule_id: schedule.id }})
    },
    fetchData () {
      this.$emit('updateData');
    },
  },
  mounted() {
    this.schedules = this.props;
  },
  watch: {
    props: {
      handler: function(to) {
        this.schedules = to;
      },
      deep: true
    },
  }
};
</script>

<style>
  .mtop{
    margin-top: 15px;
  }
</style>
